var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.menuHide,
          expression: "menuHide"
        }
      ],
      staticClass: "dots-menu-wrapper"
    },
    [
      _c(
        "button",
        { staticClass: "dots-button", on: { click: _vm.menuToggle } },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "13",
                height: "3",
                viewBox: "0 0 13 3",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }
            },
            [
              _c("circle", {
                attrs: { cx: "1.5", cy: "1.5", r: "1.5", fill: "#6D7D89" }
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: { cx: "6.5", cy: "1.5", r: "1.5", fill: "#6D7D89" }
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: { cx: "11.5", cy: "1.5", r: "1.5", fill: "#6D7D89" }
              })
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.menuActive,
              expression: "menuActive"
            }
          ],
          staticClass: "dots-menu-inner"
        },
        [
          _c(
            "div",
            { staticClass: "dots-menu-content", on: { click: _vm.menuHide } },
            [_vm._t("default")],
            2
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }